import { render, staticRenderFns } from "./customer-portal-credit-notes-viewer.vue?vue&type=template&id=4ff3f4e4&scoped=true&"
import script from "./customer-portal-credit-notes-viewer.vue?vue&type=script&lang=js&"
export * from "./customer-portal-credit-notes-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3f4e4",
  null
  
)

export default component.exports